import { mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent, useEffect, useState } from "react";
import { ModalProps } from "./modal_context";

interface ModalWidgetProps {
  data: ModalProps;
  onClose: () => void;
}

const ModalWidget: FunctionComponent<ModalWidgetProps> = (props) => {
  const [containerId, setContainerId] = useState("contaner" + props.data.id);
  const [headerId, setHeaderId] = useState("hearder" + props.data.id);

  useEffect(() => {
    dragElement(document.getElementById(containerId)!);

    function dragElement(elmnt: HTMLElement) {
      var pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;
      const header = document.getElementById(headerId);
      if (header) {
        // if present, the header is where you move the DIV from:
        header.onmousedown = dragMouseDown;
      } else {
        // otherwise, move the DIV from anywhere inside the DIV:
        elmnt.onmousedown = dragMouseDown;
      }

      function dragMouseDown(this: GlobalEventHandlers, e: MouseEvent) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(this: GlobalEventHandlers, e: MouseEvent) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:

        const {
          left = 0,
          right = 0,
          top = 0,
          bottom = 0,
        } = document.getElementById("main")?.getBoundingClientRect() || {};
        if (
          e.clientX > left &&
          e.clientX < right &&
          e.clientY > top &&
          e.clientY < bottom
        ) {
          pos1 = pos3 - e.clientX;
          pos2 = pos4 - e.clientY;
          pos3 = e.clientX;
          pos4 = e.clientY;
          // set the element's new position:
          elmnt.style.top = elmnt.offsetTop - pos2 + "px";
          elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
        }
      }

      function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
      }
    }
  }, []);
  return (
    <div className="relative">
      <div
        id="main"
        className={`fixed top-0 left-0 right-0 bottom-0  z-40  w-screen h-screen overflow-hidden  bg-black bg-opacity-25  block`}
      >
        <div className="flex h-full w-full justify-center items-center">
          <div
            id={containerId}
            className={`absolute mx-auto      shadow-lg rounded-xl bg-white zoom_wrapper`}
          >
            <div
              id={headerId}
              className="flex flex-col cursor-move    px-2 rounded-t-lg"
            >
              {" "}
              <div className="flex justify-center mt-2">
                <div className="w-20 h-1 bg-gray-400 rounded-lg"></div>
              </div>
              <div className="flex justify-between items-center">
                {" "}
                <div className="mx-3 font-semibold text-sm">
                  {props.data.title}
                </div>
                <div
                  className="p-px   rounded-full cursor-pointer   hover:text-red-600 hover:scale-110 transform"
                  onClick={props.onClose}
                >
                  <Icon path={mdiClose} size={0.8}></Icon>
                </div>
              </div>
            </div>

            <div style={{ maxHeight: "85vh" }} className="overflow-y-auto p-5">
              {props.children || props.data.container}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalWidget;
